import "./component.scss";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["count"];

  connect() {
    if (!this.hasCountTarget) return;
    this.observer = new MutationObserver(() => this.#triggerPop());
    this.observer.observe(this.countTarget, { childList: true, characterData: true, subtree: true });
  }

  disconnect() {
    this.observer?.disconnect();
  }

  #triggerPop() {
    const el = this.countTarget;
    el.removeAttribute("data-animating");
    void el.offsetWidth;
    el.setAttribute("data-animating", "");
  }
}
